<template>
  <div aria-hidden="false" aria-labelledby="myModalLabel" role="dialog" tabindex="-1" id="dialog" class="modal fade in" :style="{display: showflag?'block':'none'}">
    <div class="binding-content" @click="close">
      <div class="knowledge-base-name">{{ message }}</div>
      <div class="knowledge-tag-head">
        <img src="../../../static/images/two-codes.png">
         <div class="right">
           <p>抱歉目前您没有此权限 </p>
            请扫描左方二维码联系小助手获取权限<br>
         </div>
      </div>
    </div>
  </div>
  <div class="modal-backdrop fade in" :style="{display: showflag?'block':'none'}"></div>
</template>

<script>
export default {
  name: 'VipDialogView'
}
</script>



/** WEBPACK FOOTER **
 ** VipDialog.vue?e6f9e0ee
 **/